// @flow
import React from "react";
import type { Map } from "immutable";
import "./ApAssetBlock.scss";

type Props = {
  block: {
    data: Map<string, any>
  }
};

export default class ApAssetBlock extends React.Component {
  state: {
    assetId: number,
    dataLoaded: boolean,
    data: {
      title?: string,
      filename?: string,
      cms_thumbnail_url?: string
    }
  };
  props: Props;

  constructor(props: Props) {
    super(props);
    (this: any).loadData = this.loadData.bind(this);

    this.state = {
      assetId: props.block.data.get("assetId"),
      dataLoaded: false,
      data: {}
    };

    this.loadData();
  }

  async loadData() {
    const resp = await fetch(`/api/core/assets/${this.state.assetId}`, {
      credentials: "same-origin"
    });
    const data = await resp.json();
    this.setState({
      dataLoaded: true,
      data: data
    });
  }

  render() {
    if (!this.state.dataLoaded) {
      return null;
    }

    return (
      <div
        className="wysiwyg-ap-asset-block"
        data-asset_id={this.state.assetId}
      >
        <img src={this.state.data.cms_thumbnail_url} />
        <div className="details">
          <h2>{this.state.data.title}</h2>
          <h3>{this.state.data.filename}</h3>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./enso_cms/static/enso-cms/js/components/ApAssetBlock.js